import React from 'react';
import { BrowserRouter, Route, Router, Switch } from 'react-router-dom';
import history from "./components/others/redirect";
import LoginPage from './components/login/LoginPage';
import { ToastContainer } from 'react-toastify';
import { MDBCol, MDBContainer } from 'mdbreact';
import { observer } from 'mobx-react';
import { AppStore } from './stores/AppStore';
import { PerfilStore } from './stores/perfil/PerfilStore';
import moment from 'moment';
import CstCsosnPage from './components/legislacao/CstCsosnPage';
import PisCofinsPage from './components/legislacao/PisCofinsPage';
import ProdutosPage from './components/produto/ProdutosPage';
import EansPage from './components/legislacao/EansPage';
import { CnaePage } from './components/legislacao/CnaePage';
import { TipiPage } from './components/legislacao/TipiPage';
import PerfilPage from './components/perfil/PerfilPage';
import LogsPage from './components/logs/LogsPage';
import ErrosNotasPage from './components/erros/ErrosNotasPage';
import NFesPage from './components/nfes/NFesPage';
import CentralAcoesPage from './components/central-acoes/CentralAcoesPage';
import SefaPage from './components/sefa/SefaPage';
import ManifestacoesPage from './components/manifestacoes/ManifestacoesPage';
import ResultadosPage from './components/resultados/ResultadosPage';
import ImportPage from './components/imports/ImportPage';
import FornecedoresPage from './components/relatorios/FornecedoresPage';
import ClientesPage from './components/relatorios/ClientesPage';
import IntegracoesPage from './components/relatorios/IntegracoesPage';
import AlteracaoPlanoPage from './components/alteracoes-plano/AlteracaoPlanoPage';
import AssinaturaPendentePage from './components/assinatura/AssinaturaPendentePage';
import AssinaturaContratoPage from './components/assinatura/AssinaturaContratoPage';
import AssinaturaBloqueadaPage from './components/assinatura/AssinaturaBloqueadaPage';
import EmpresasPage from './components/empresa/EmpresasPage';
import EmpresaForm from './components/empresa/EmpresaForm';
import EmpresaCreatePlan from './components/empresa/EmpresaCreatePlan';
import MemoriaCalculo from './components/memoria-calculo/MemoriaCalculo';
import AssinaturaAguardandoPage from './components/assinatura/AssinaturaAguardandoPage';
import PagamentoPendentePage from './components/pagamentos/PagamentoPendentePage';
import NotaVarsPage from './components/vars/NotaVarsPage';
import CalcsPage from './components/calculos/CalcsPage';
import CalcForm from './components/calculos/CalcForm';
import IcmsAliquotasPage from './components/icms-aliquotas/IcmsAliquotasPage';
import { LegisWebLucroPage } from './components/admin/LegisWebLucroPage';
import { LegisWebSimplesPage } from './components/admin/LegisWebSimplesPage';
import NotaVarForm from './components/vars/NotaVarForm';
import AutenticacaoPage from './components/login/AutenticacaoPage';
import ResponseRestorePage from './components/login/ResponseRestorePage';
import RestorePasswordPage from './components/login/RestorePasswordPage';
import ChangePassword from './components/login/ChangePassword';
import CreateUsuarioPage from './components/login/CreateUsuarioPage';
import CreateContaPage from './components/login/CreateContaPage';
import Header from './components/header/Header';
import DashboardPage from './components/dashboard/DashboardPage';
import LoadingPage from './components/utils/LoadingPage';
import { Classes } from '@blueprintjs/core';
import MvasPaPage from './components/mvas-pa/MvasPaPage';
import MvasRsPage from './components/mvas-rs/MvasRsPage';
import CalcRsForm from './components/calculos-rs/CalcRsForm';
import CalcsRsPage from './components/calculos-rs/CalcsRsPage';
import NotaVarsFcpPage from './components/vars-rs/NotaVarsFcpPage';
import NotaVarFcpForm from './components/vars-rs/NotaVarFcpForm';
import PautaRsPage from './components/admin/PautaRsPage';
import SpedPage from './components/sped/SpedPage';
import EmpresaCreateForm from './components/empresa/EmpresaCreateForm';
import ContasPage from './components/admin/ContasPage';
import LoginAdmPage from './components/login/LoginAdmPage';

import "/node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import "/node_modules/bootstrap-css-only/css/bootstrap.min.css";
import "/node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import "react-virtualized/styles.css";
import 'react-toastify/dist/ReactToastify.css';
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import "@blueprintjs/select/lib/css/blueprint-select.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'react-folder-tree/dist/style.css';
import 'react-phone-input-2/lib/style.css'

import RelatorioPage from './components/relatorios/RelatorioPage';
import RelatorioFiltro from './components/relatorios/relatorio/RelatorioFiltro';
import AssinaturaAtivar from './components/assinatura/AssinaturaAtivar';
import ClassificacaoPage from './components/classificacao/ClassificacaoPage';
import PgdasPage from './components/pgdas/PgdasPage';
import SitfisPage from './components/sitfis/SitfisPage';
import CaixaPostalPage from './components/caixa-postal/CaixaPostalPage';
import { TabelaSimplesPage } from './components/admin/TabelaSimplesPage';
import Draggable from 'react-draggable';
import ReleasesPage from './components/releases/ReleasesPage';
import DecPage from './components/dec_sefa/DecPage';
import { TabelaSimplesExcessoPage } from './components/admin/TabelaSimplesExcessoPage';
import MonofasicoSimplesPage from './components/monofasico-simples/MonofasicoSimplesPage';
import IntegrationPage from './components/xml-integration/IntegrationPage';
import { EmpresasAdminPage } from './components/admin/EmpresasAdminPage';
import CndsPage from './components/cnds/CndsPage';
import CstOrigemPage from './components/legislacao/CstOrigemPage';
import TribuNacionalPage from './components/legislacao/TribuNacionalPage';
import CfopsPage from './components/legislacao/CfopsPage';
import FgtsDigitalPage from './components/fgts-digital/FgtsDigitalPage';
import { BotsAdminPage } from './components/admin/BotsAdminPage';
import { BotsPage } from './components/relatorios/BotsPage';
import ParauapebasPage from './components/parauapebas/ParauapebasPage';
import Sidebar from './components/sidebar/Sidebar';
import { AjusteSped } from './components/admin/AjusteSped';
import { SpedTabelasPage } from './components/sped-tabelas/SpedTabelasPage';
import VncPage from './components/vnc/vnc';
import DashboardUserPage from './components/dashboard/DashboardUserPage';
import NfeFazendaPage from './components/nfe-fazenda/NfeFazendaPage';
import CalcVarsPage from './components/calc-vars/CalcVarsPage';
import ParcelamentosPage from './components/parcelamentos/ParcelamentosPage';
import SpedPlanilhaPage from './components/sped/SpedPlanilhaPage';
import DeiPage from './components/dei/DeiPage';
import FaixaSimplesPage from './components/relatorios/FaixaSimplesPage';
import RelatorioParcelamentoPage from './components/relatorios/RelatorioParcelamentoPage';
import { RelatorioNfeForm } from './components/relatorios/relatorio/RelatorioNfeForm';
import { RelatorioCteForm } from './components/relatorios/relatorio/RelatorioCteForm';
import { RelatorioNfceForm } from './components/relatorios/relatorio/RelatorioNfceForm';
import { RelatorioNfseForm } from './components/relatorios/relatorio/RelatorioNfseForm';
import SpedTxtPage from './components/sped/SpedTxtPage';
import IntegracoesChaveTokenPage from './components/relatorios/IntegracoesChaveTokenPage';
import DetPage from './components/det/DetPage';
import CalculoManifestacaoPage from './components/relatorios/CalculoManifestacaoPage';
import MonitoraTopicPage from './components/monitora/MonitoraTopicPage';
import { AgendamentosAdminPage } from './components/admin/AgendamentoAdmingPage';
import NsuManifestascaoPage from './components/manifestacoes/NsuManifestascaoPage';
import { StatusPage } from './components/status/StatusPage';
import { StatusStore } from './stores/status/StatusStore';

require("../src/assets/css/style.css")
require("../src/assets/css/responsive.css")
require("../src/assets/css/main.css")

@observer
export default class App extends React.Component<{}, {}> {
  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
    AppStore.obs1.logged = false

    let routers = [
      "login",
      "conta",
      "alterar-senha",
      "esqueci-minha-senha",
      "senha-alterada",
      "",
      "/"
    ]

    if (routers.indexOf(window.location.pathname.split("/")[1]) == -1) {
      await StatusStore.handleStatusAll()
      await AppStore.loadUsuario()
      await PerfilStore.getAssinatura()
      await AppStore.loadStats();
      await AppStore.handleIndexReleases(1)

      if (AppStore.obs1.usuario._id == "") {
        return history.push("/")
      }

      AppStore.obs1.logged = true

      if (AppStore.obs1.usuario) {
        if (AppStore.obs1.usuario.contrato) {
          if (AppStore.obs1.usuario.contrato.assinado != undefined) {
            PerfilStore.obs.contrato_assinado = AppStore.obs1.usuario.contrato.assinado
          }
        }
      }
    }

  }

  renderSistema() {
    let userPermissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.user_empresa : false;
    // let teste_gratis = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste_rapido : false;
    let data_cadastro = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.inserted_at : "000-00-00";
    let plus_test_days = (AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.plus_test_days : 0) ?? 0

    let is_teste = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;
    let statusAtivacao = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.status_pagamento == "PENDING" : false;

    let libera_pagamento = AppStore.obs1.usuario
      ? AppStore.obs1.usuario.conta.libera_pagamento
      : false;
    let libera_contrato = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.libera_contrato : false;

    let agora = moment(new Date());
    let fimTeste = moment(data_cadastro).add(5 + plus_test_days, 'days');
    let testeTerminou = agora.isSameOrAfter(fimTeste);

    let dias: number = 0;
    if (AppStore.obs1.usuario) {
      if (AppStore.obs1.usuario.conta.iugu_fatura != null) {
        if (AppStore.obs1.usuario.conta.iugu_fatura["status"] != "paid" && AppStore.obs1.usuario.conta.iugu_fatura["status"] != "externally_paid") {
          let dataFat = AppStore.obs1.usuario.conta.iugu_fatura["data_fatura"];
          let today = moment(new Date());
          var duration = moment.duration(today.diff(dataFat));
          dias = (Math.floor(duration.asDays()));
        }
      }

      let iugu_pagamento: boolean = true

      if (typeof AppStore.obs1.usuario.conta.fatura_ativacao == 'string') {
        iugu_pagamento = false
      }

      return (
        <>
          <div>
            {/* <MDBContainer fluid className="backTopo"> */}
              <Header />
            {/* </MDBContainer> */}
            <div className="clearfix"></div>
            <MDBContainer fluid className="backBody">
              <MDBCol xl="12" style={{ marginBottom: "25px" }}>
                <div className="nz-app-location">
                  <ul className={Classes.BREADCRUMBS}>
                    <li>
                      <span
                        className={`${Classes.BREADCRUMB} ${Classes.BREADCRUMB_CURRENT}`}
                      >
                        {AppStore.obs1.title}
                      </span>
                    </li>
                  </ul>
                </div>
              </MDBCol>
              <MDBCol xl="12">
                {AppStore.obs1.usuario.admin &&
                  <>
                    <Route path="/tarefas-admin" component={BotsAdminPage} />

                    <Route path="/contas" component={ContasPage} />
                    <Route path="/empresas-admin" component={EmpresasAdminPage} />

                    <Route path="/var/create" component={NotaVarForm} />
                    <Route path="/var/edit/:id" component={NotaVarForm} />
                    <Route path="/vars" component={NotaVarsPage} />

                    <Route path="/var-fcp/create" component={NotaVarFcpForm} />
                    <Route path="/var-fcp/edit/:id" component={NotaVarFcpForm} />
                    <Route path="/vars-fcp" component={NotaVarsFcpPage} />

                    <Route path="/vars-calc" component={CalcVarsPage} />

                    <Route path="/calcs" component={CalcsPage} />
                    <Route path="/calc/create" component={CalcForm} />
                    <Route path="/calc/edit/:id" component={CalcForm} />

                    <Route path="/calcs-rs" component={CalcsRsPage} />
                    <Route path="/calc-rs/create" component={CalcRsForm} />
                    <Route path="/calc-rs/edit/:id" component={CalcRsForm} />

                    <Route path="/legis-web-simples" component={LegisWebSimplesPage} />
                    <Route path="/legis-web-lucro" component={LegisWebLucroPage} />
                    <Route path="/pauta-rs" component={PautaRsPage} />

                    <Route path="/tabela-simples" component={TabelaSimplesPage} />
                    <Route path="/tabela-simples-excesso" component={TabelaSimplesExcessoPage} />

                    <Route path="/tabelas-sped" component={SpedTabelasPage} />
                    <Route path="/ajustes-sped" component={AjusteSped} />
                    <Route path="/vnc" component={VncPage} />
                    <Route path="/monitorar-topics" component={MonitoraTopicPage} />
                    
                    <Route path="/agendamentos-admin" component={AgendamentosAdminPage} />
                    <Route path="/nsu-manifestacao" component={NsuManifestascaoPage} />
                    
                    <Route path="/status" component={StatusPage} />

                  </>
                }

                {/* {teste_gratis ?
                  <>
                    <Route path="/resultados" component={ResultadosPage} />
                    <Route path="/assinar-plano" component={AssinaturaPendentePage} />
                  </>

                  : */}

                  {is_teste && !iugu_pagamento && testeTerminou ?
                    <>
                      <Route path="/assinatura-aguardando" component={AssinaturaAguardandoPage} />
                      <Route path="/*" component={AssinaturaAguardandoPage} />
                    </>

                    :

                    dias > 7 && !libera_pagamento ?
                      <>
                        <Route path="/pendente" component={PagamentoPendentePage} />
                        <Route path="/*" component={PagamentoPendentePage} />
                      </>
                      :

                      !is_teste && !PerfilStore.obs.contrato_assinado && !AppStore.obs1.usuario.admin && !libera_contrato ?
                        <>
                          <Route path="/perfil" component={PerfilPage} />
                          <Route path="/assinar-contrato" component={AssinaturaContratoPage} />
                          <Route path="/*" component={AssinaturaContratoPage} />
                        </>

                        :

                          AppStore.obs1.usuario && testeTerminou && is_teste && !statusAtivacao ?
                            <>
                              <Route path="/selecionar-planos" component={AssinaturaPendentePage} />
                              <Route path="/assinar-plano" component={AssinaturaAtivar} />
                              <Route path="/empresa/plan" component={EmpresaCreatePlan} />
                              <Route path="/empresa/create" component={EmpresaCreateForm} />
                              <Route path="/empresa/edit/:id" component={EmpresaForm} />
                              <Route path="/empresas" component={EmpresasPage} />

                            </>
                            :
                            <>
                              {userPermissao 
                                ?(<>
                                  <Route path="/dashboard" component={DashboardUserPage} />
                                  <Route path="/classificacao" component={ClassificacaoPage} />
                                </>)
                                : (<>
                                  <Route path="/dashboard" component={DashboardPage} />
                                  <Route path="/empresa/plan" component={EmpresaCreatePlan} />
                                  <Route path="/empresa/create" component={EmpresaCreateForm} />
                                  <Route path="/empresa/edit/:id" component={EmpresaForm} />
                                  <Route path="/empresas" component={EmpresasPage} />
                                </>)
                              }

                              <Route path="/memoria-calculo" component={MemoriaCalculo} />

                              {is_teste && !statusAtivacao &&
                                <>
                                  <Route path="/selecionar-planos" component={AssinaturaPendentePage} />
                                  <Route path="/assinar-plano" component={AssinaturaAtivar} />
                                </>
                              }

                              <Route path="/assinar-contrato" component={AssinaturaContratoPage} />
                              <Route path="/alteracoes-plano" component={AlteracaoPlanoPage} />
                              <Route path="/assinatura-bloqueada" component={AssinaturaBloqueadaPage} />
                              <Route path="/fornecedores" component={FornecedoresPage} />
                              <Route path="/clientes" component={ClientesPage} />
                              <Route path="/pgdas" component={PgdasPage} />
                              <Route path="/imports" component={ImportPage} />
                              <Route path="/resultados" component={ResultadosPage} />
                              <Route path="/historico-notas" component={ManifestacoesPage} />
                              <Route path="/solicitacoes-sefa" component={SefaPage} />
                              {/* <Route path="/nfs-prefeitura" component={NfePrefeituraPage} /> */}
                              <Route path="/nfes" component={NFesPage} />
                              <Route path="/erros-notas" component={ErrosNotasPage} />
                              <Route path="/logs" component={LogsPage} />
                              <Route path="/perfil" component={PerfilPage} />
                              <Route path="/central-de-acoes" component={CentralAcoesPage} />
                              <Route path="/tipi" component={TipiPage} />
                              <Route path="/cnae" component={CnaePage} />
                              <Route path="/eans" component={EansPage} />
                              <Route path="/produtos" render={(props) => <ProdutosPage {...props} estado="PA" />} />
                              <Route path="/produtos-rs" render={(props) => <ProdutosPage {...props} estado="RS" />} />
                              <Route path="/pis-cofins" component={PisCofinsPage} />
                              <Route path="/cst-cson" component={CstCsosnPage} />
                              <Route path="/sped" component={SpedPage} />

                              <Route path="/relatorios" component={RelatorioPage} />
                              <Route path="/relatorio/create-nfe" component={RelatorioNfeForm} />
                              <Route path="/relatorio/create-cte" component={RelatorioCteForm} />
                              <Route path="/relatorio/create-nfce" component={RelatorioNfceForm} />
                              <Route path="/relatorio/create-nfse" component={RelatorioNfseForm} />
                              <Route path="/relatorio/filtro" component={RelatorioFiltro} />
                              {/* <Route path="/downloads-xml" component={DownloadXmlPage} /> */}
                              <Route path="/sitfis" component={SitfisPage} />
                              <Route path="/caixa-postal" component={CaixaPostalPage} />
                              <Route path="/releases" component={ReleasesPage} />
                              <Route path="/dec-sefa" component={DecPage} />
                              <Route path="/mvas-pa" component={MvasPaPage} />
                              <Route path="/mvas-rs" component={MvasRsPage} />
                              <Route path="/icms-aliquotas" component={IcmsAliquotasPage} />
                              <Route path="/monofasico-simples" component={MonofasicoSimplesPage} />
                              <Route path="/xml-integration" component={IntegrationPage} />
                              <Route path="/cnds" component={CndsPage} />
                              <Route path="/cst-origem" component={CstOrigemPage} />
                              <Route path="/tributacao-nacional" component={TribuNacionalPage} />
                              <Route path="/cfops" component={CfopsPage} />
                              <Route path="/fgts-digital" component={FgtsDigitalPage} />
                              <Route path="/tarefas" component={BotsPage} />
                              <Route path="/nfse-prefeitura" component={ParauapebasPage} />
                              <Route path="/portal-nfe" component={NfeFazendaPage} />
                              <Route path="/parcelamentos" component={ParcelamentosPage} />
                              <Route path="/sped-planilha" component={SpedPlanilhaPage} />
                              <Route path="/sped-txt" component={SpedTxtPage} />
                              <Route path="/integracoes" component={IntegracoesPage} />
                              <Route path="/confirmacao-chaves-tokens" component={IntegracoesChaveTokenPage} />
                              <Route path="/relatorio_parcelamento" component={RelatorioParcelamentoPage} />
                              <Route path="/dei" component={DeiPage} />
                              <Route path="/faixa-simples" component={FaixaSimplesPage} />
                              <Route path="/det" component={DetPage} />
                              <Route path="/calculo-manifestacao" component={CalculoManifestacaoPage} />
                            </>
                }
              </MDBCol>
            </MDBContainer>
          </div>
        </>
      )
    }
  }

  render() {

    const handleClick = () => {
      window.open(`https://api.whatsapp.com/send?phone=54920004300&text=Ol%C3%A1!`, '_blank');
    };

    return (
      <div>
        <ToastContainer limit={1} className="toast_geral" autoClose={3000} position='top-center' />

        <Draggable>
          <div className="whatsapp-widget">
            <img
              src="/images/whatsapp.png"
              onClick={handleClick}
              width={30}
            />
          </div>
        </Draggable>

        <BrowserRouter>
          <Router history={history}>
            <Switch>
              <Route path="/" exact component={LoginPage} />
              <Route path="/login" exact component={LoginPage} />
              <Route path="/login/adm" component={LoginAdmPage} />
              <Route path="/conta/criar" component={CreateContaPage} />
              <Route path="/conta/usuario" component={CreateUsuarioPage} />
              <Route path="/conta/autenticar" component={AutenticacaoPage} />
              <Route path="/alterar-senha/:id" component={ChangePassword} />
              <Route path="/esqueci-minha-senha" component={RestorePasswordPage} />
              <Route path="/senha-alterada" component={ResponseRestorePage} />

              {AppStore.obs1.logged ?
                this.renderSistema()
                :
                <LoadingPage />
              }
            </Switch>
          </Router>
        </BrowserRouter>
      </div>
    );
  }
}
